import { WeaponData } from "./ApexDPS";

export const guns:WeaponData[] =
[
  {
    name: "CAR",
    type: "SMG",
    ammo: "heavy",
    dmg: 14,
    rpm: 930,
  },
  {
    name: "R-99",
    type: "SMG",
    ammo: "light",
    dmg:13,
    rpm: 1080
  },
  {
    name: "オルタネーター",
    type: "SMG",
    ammo: "light",
    dmg:19,
    rpm: 600
  },
  {
    name: "オルタネーター(ダブルタップ)",
    type: "SMG",
    ammo: "light",
    dmg: 15,
    pellet: 2,
    rpm: 468
  },
  {
    name: "ボルト",
    type: "SMG",
    ammo: "energy",
    dmg: 16,
    rpm: 720
  },
  {
    name: "プラウラー",
    type: "SMG",
    ammo: "heavy",
    dmg: 16,
    rpm: 1260,
    burst: 5,
    burst_delay: 0.23
  },
  {
    name: "プラウラー(オート)",
    type: "SMG",
    ammo: "heavy",
    dmg: 17,
    rpm: 800
  },
  {
    name: "EVA-8",
    type: "SG",
    ammo: "shotgun",
    dmg:7,
    pellet: 8,
    rpm: 162,
    rpm_1: 175,
    rpm_2: 186,
    rpm_3: 192
  },
  {
    name: "EVA-8(ダブルタップ)*",
    type: "SG",
    ammo: "shotgun",
    dmg: 7,
    pellet: 16,
    rpm: 75,
    rpm_1: 78,
    rpm_2: 81,
    rpm_3: 84
  },
  {
    name: "ピースキーパー",
    type: "SG",
    ammo: "shotgun",
    dmg:11,
    pellet: 9,
    rpm: 66,
    rpm_1: 73,
    rpm_2: 75,
    rpm_3: 78
  },
  {
    name: "ピースキーパー(ディスラプター)",
    type: "SG",
    ammo: "shotgun",
    dmg: 11,
    pellet: 9,
    disruptor: 1.1,
    rpm: 66,
    rpm_1: 73,
    rpm_2: 75,
    rpm_3: 78
  },
  {
    name: "マスティフ",
    type: "SG",
    ammo: "shotgun",
    dmg: 19,
    pellet: 5,
    rpm: 66,
    rpm_1: 73,
    rpm_2: 75,
    rpm_3: 78
  },
  {
    name: "モザンビーク",
    type: "SG",
    ammo: "shotgun",
    dmg:17,
    pellet: 3,
    rpm: 164,
    rpm_1: 172,
    rpm_2: 180,
    rpm_3: 190
  },
  {
    name: "モザンビーク(アキンボ)",
    type: "SG",
    ammo: "shotgun",
    dmg:17,
    pellet: 3,
    rpm: 180,
    rpm_1: 190,
    rpm_2: 200,
    rpm_3: 200
  },
  {
    name: "P2020",
    type: "P",
    ammo: "light",
    dmg: 24,
    rpm: 400
  },
  {
    name: "P2020(アキンボ)",
    type: "P",
    ammo: "light",
    dmg: 24,
    rpm: 450
  },
  {
    name: "P2020(ハンマー)",
    type: "P",
    ammo: "light",
    dmg: 24,
    hammer: 1.1,
    rpm: 400
  },
  {
    name: "P2020(ハンマー+アキンボ)",
    type: "P",
    ammo: "light",
    dmg: 24,
    hammer: 1.1,
    rpm: 450
  },
  {
    name: "RE-45バースト",
    type: "P",
    ammo: "energy",
    dmg: 17,
    rpm: 2400,
    delay: 0.25,
    burst: 3,
    burst_delay: 0.19
  },
  {
    name: "ウィングマン",
    type: "P",
    ammo: "sniper",
    dmg:50,
    rpm: 170
  },
  {
    name: "フラットライン",
    type: "AR",
    ammo: "heavy",
    dmg: 20,
    rpm: 600
  },
  {
    name: "ネメシス*",
    type: "AR",
    ammo: "energy",
    dmg:17,
    rpm: 1080,
    burst: 4,
    burst_delay: 0.18
  },
  {
    name: "ハボック",
    type: "AR",
    ammo: "energy",
    dmg:20,
    rpm: 672,
    delay: 0.42
  },
  {
    name: "R-301",
    type: "AR",
    ammo: "light",
    dmg: 15,
    rpm: 810
  },
  {
    name: "ヘムロック",
    type: "AR",
    ammo: "heavy",
    dmg: 22,
    rpm: 460
  },
  {
    name: "スピットファイア",
    type: "LMG",
    ammo: "light",
    dmg:21,
    rpm: 540
  },
  {
    name: "L-スター*",
    type: "LMG",
    ammo: "energy",
    dmg: 20,
    rpm: 600,
    care_package: true,
  },
  {
    name: "ディヴォーション",
    type: "LMG",
    ammo: "energy",
    dmg:16,
    rpm_base: 300,
    rpm: 900,
    accel: 1.75
  },
  {
    name: "ランページ",
    type: "LMG",
    ammo: "heavy",
    dmg:29,
    rpm: 300
  },
  {
    name: "ランページ(増幅中)",
    type: "LMG",
    ammo: "heavy",
    dmg:29,
    rpm: 390
  },
  {
    name: "シーラ",
    type: "MG",
    ammo: "legend",
    dmg: 14,
    rpm: 1200,
    delay: 1.25
  },
  {
    name: "G7スカウト",
    type: "MR",
    ammo: "light",
    dmg: 37,
    rpm: 264,
    care_package: true
  },
  {
    name: "G7スカウト(ダブルタップ)*",
    type: "MR",
    ammo: "light",
    dmg: 37,
    pellet: 2,
    rpm: 132,
    care_package: true
  },
  {
    name: "ボセック",
    type: "MR",
    ammo: "arrow",
    dmg: 60,
    rpm: 66
  },
  {
    name: "30-30*",
    type: "MR",
    ammo: "heavy",
    dmg: 60,
    rpm: 132
  },
  {
    name: "トリプルテイク",
    type: "MR",
    ammo: "energy",
    dmg:22,
    pellet: 3,
    rpm: 80
  },
  {
    name: "トリプルテイク(腰撃ち)",
    type: "MR",
    ammo: "energy",
    dmg:22,
    pellet: 3,
    rpm: 108
  },
  {
    name: "クレーバー",
    type: "SR",
    ammo: "sniper",
    dmg:150,
    rpm: 25,
    care_package: true
  },
  {
    name: "センチネル",
    type: "SR",
    ammo: "sniper",
    dmg:70,
    rpm: 37.5
  },
  {
    name: "センチネル(増幅中)",
    type: "SR",
    ammo: "sniper",
    dmg:88,
    rpm: 40
  },
  {
    name: "チャージライフル*",
    type: "SR",
    ammo: "sniper",
    dmg:75,
    rpm: 50,
    delay: 0.85
  },
  {
    name: "ロングボウ",
    type: "SR",
    ammo: "sniper",
    dmg:60,
    rpm: 78
  },
  {
    name: "スナイパーズマーク*",
    type: "SR",
    ammo: "legend",
    dmg: 50,
    rpm: 45
  }
]
